
import { Box, Container, Grid } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useAppContext } from "../../../../libs/app-core/AppContext";
import { Toast } from "../../../../libs/app-core/Toast";
import { useGridApiRef } from "../../../../libs/data-grid-view/useGridApiRef";
import { linear_content_style, linear_h, linear_item, linear_v } from "../../../../libs/linear-layout/LinearLayout";
import Title from "../../../../libs/rhf-mui/ui/Title";
import { ROUTE_dev_project_editor } from "../../../Routes";
import AppMenuButton from "../../../components/AppMenuButton";
import Blocker from "../../../components/Blocker";
import { useProjectList } from "../../../dao/ProjectDAO";
import { R } from "../../../R";

type Props = {}

const FrmDevProjectList = (props: Props) => {
  const grid_api = useGridApiRef(columns);

  const ctx = useAppContext();
  const { _ProjectList } = useProjectList(true);

  if (_ProjectList === undefined) {
    return <Blocker />;
  }


  return (
    <Box style={linear_content_style} bgcolor={R.color.paper}>
      <Container sx={{ height: '100%', pb: 3, pt: 2 }}>
        <Grid {...linear_v} >
          <Grid {...linear_item}  >
            {render_ActionBar()}
          </Grid>
          <Grid {...linear_item} flex={1} >
            {render_DataGrid()}
          </Grid>
        </Grid>
      </Container>
    </Box>
  )

  function render_ActionBar() {
    return (<Grid  {...linear_h} alignItems='center' p={1}>
      {<AppMenuButton label={<Title color='error'>[DEV] 場次列表 </Title>} />}

      <Grid {...linear_item} flex={1}>
      </Grid>
      <Grid {...linear_item}>
        <Title>...</Title>
      </Grid>
    </Grid>);
  }

  function render_DataGrid() {
    return (
      <DataGrid style={{ width: '100%', backgroundColor: 'white', padding: '12px' }}
        getRowId={(data) => { return data.guid }}
        rows={_ProjectList ?? []}
        columns={grid_api.columns}
        pageSize={20}
        rowsPerPageOptions={[20]}
        onRowDoubleClick={(params) => {
          ctx.Navigate(ROUTE_dev_project_editor.url + "?project=" + params.id);
          Toast.Show(ctx, "專案: " + params.id);
        }}
      />
    );
  }

}



const columns: GridColDef[] = [
  { field: 'serno', headerName: 'ID', width: 90 },
  { field: 'project_code', headerName: '場次編號', width: 150 },
  { field: 'project_name', headerName: '場次名稱', width: 320 },
];


export default FrmDevProjectList